export default "__VITE_ASSET__BwAmAEH9__"